export default "/institutions/wiipo.svg";